export default {
	styleOverrides: {
		root: {}
	},
	defaultProps: {
		disableRipple: true
	}
};
